var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.384 32.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25010",
    "data-name": "Path 25010",
    d: "M3.856,15.886H6.314V26.514H4.188a1.063,1.063,0,0,0,0,2.126H29.7a1.063,1.063,0,1,0,0-2.126H27.57V15.886h2.458a2.119,2.119,0,0,0,1.964-1.311,2.145,2.145,0,0,0-.525-2.376L19,1.648a3.18,3.18,0,0,0-4.119,0L2.417,12.2l-.065.06a2.125,2.125,0,0,0,1.5,3.628Zm4.584,0h4.251V26.514H8.44ZM19.067,26.514H14.816V15.886h4.251Zm6.377,0H21.193V15.886h4.251ZM16.255,3.27a1.062,1.062,0,0,1,1.373,0l12.4,10.491-26.177.007ZM32.884,31.828a1.063,1.063,0,0,1-1.063,1.063H2.063a1.063,1.063,0,0,1,0-2.126H31.821A1.063,1.063,0,0,1,32.884,31.828Z",
    transform: "translate(-0.75 -0.517)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProcessing);
export default __webpack_public_path__ + "static/media/BankProcessing.e1160f5e1653842b25f236504329ea02.svg";
export { ForwardRef as ReactComponent };